// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreMoqRules = (client) => ({
    /**
     * `GET /store/moq-rules`
     *
     * @operationId StoreListMoqRules
     * @source packages/medusa-plugin-moq-v2/src/api/store/moq-rules/route.ts
     */
    list: (query, headers) => client.fetch("/store/moq-rules", { method: "GET", query, headers }),
});
//# sourceMappingURL=moq-rules.js.map